import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";

gsap.registerPlugin(ScrollTrigger, SplitText);

const paragraphModule = (props) => {

    let texts = document.querySelectorAll('.js-text-animate');
    let splitInstances = []; // Store SplitText instances for cleanup

    // Debounced resize function
    let resizeTimeout;
    const handleResize = () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            // Refresh all SplitText instances
            splitInstances.forEach(split => {
                if (split && split.revert) {
                    split.revert();
                }
            });
            splitInstances = [];

            // Reinitialize all animations
            initializeAnimations();
        }, 250); // Wait 250ms after resize stops
    };

    const initializeAnimations = () => {
        texts.forEach((text) => {
            let additionalDelay = text.getAttribute('data-additional-delay') ? text.getAttribute('data-additional-delay') : 0;

            text.querySelectorAll('p').forEach((paragraph, index) => {

                // ScrollTrigger.matchMedia({
                //     "(pointer: fine)": () => {

                        const split = new SplitText(paragraph, {
                            type: "lines",
                            linesClass: "line"
                        });

                        // Store the instance for cleanup
                        splitInstances.push(split);

                        const lines = split.lines;

                        gsap.set(lines, { y: 30, autoAlpha: 0 });

                        gsap.to(lines, {
                            y: 0,
                            autoAlpha: 1,
                            duration: 0.7,
                            delay: parseFloat(additionalDelay) + index * lines.length * 0.04,
                            ease: "power2.out",
                            stagger: {
                                amount: 0.15,
                            },
                            scrollTrigger: {
                                trigger: text,
                                start: "top 80%",
                            }
                        });

                //     }
                // });

            });
        });
    };

    // Initialize animations
    initializeAnimations();

    // Use ScrollTrigger.matchMedia to only add resize listener for fine pointer devices
    ScrollTrigger.matchMedia({
        "(pointer: fine)": () => {
            // Add resize listener only for devices with fine pointer (desktop)
            window.addEventListener('resize', handleResize);

            // Return cleanup function for this media query
            return () => {
                window.removeEventListener('resize', handleResize);
            };
        }
    });

    // Cleanup function (can be called when component unmounts)
    const cleanup = () => {
        // Kill all ScrollTrigger instances
        ScrollTrigger.getAll().forEach(trigger => trigger.kill());

        // Clean up SplitText instances
        splitInstances.forEach(split => {
            if (split && split.revert) {
                split.revert();
            }
        });
        splitInstances = [];
    };

    // Return cleanup function for external use
    return { cleanup };
}

export { paragraphModule };